export const MAX_CONTACTS_MIN = 1;
export const MAX_CONTACTS_MAX = 50;
export const DEFAULT_MAX_CONTACTS = 10;

export const isValidMaxContacts = (value) =>
	Number.isInteger(value) && value >= MAX_CONTACTS_MIN && value <= MAX_CONTACTS_MAX;
